export const onTitleCellHandler = (record, rowIndex) => ({
  onMouseOver: (event: any) => {
    const { currentTarget } = event;
    const tableBody = currentTarget.parentNode.parentNode;
    setTimeout(() => {
      for (let i = 1; i < tableBody.children.length; i++) {
        const childTr = tableBody.children[i];
        if (i - 1 === rowIndex) {
          for (let j = 0; j < childTr.children.length; j++) {
            childTr.children[j].classList.add('tralit-table-cell-row-hover');
          }
        } else {
          for (let j = 0; j < childTr.children.length; j++) {
            childTr.children[j].classList.remove('tralit-table-cell-row-hover');
          }
        }
      }
    });
  },
});

export const onDataCellHandler = (record, rowIndex) => ({
  onMouseOver: (event: any) => {
    const { currentTarget } = event;
    const columnIndex = Array.prototype.indexOf.call(currentTarget.parentNode.children, currentTarget);
    const tableBody = currentTarget.parentNode.parentNode;
    setTimeout(() => {
      for (let i = 1; i < tableBody.children.length; i++) {
        const childTr = tableBody.children[i];
        if (i - 1 === rowIndex) {
          for (let j = 0; j < childTr.children.length; j++) {
            childTr.children[j].classList.add('tralit-table-cell-row-hover');
          }
        } else {
          for (let j = 0; j < childTr.children.length; j++) {
            childTr.children[j].classList.remove('tralit-table-cell-row-hover');
          }
        }
        if (childTr && childTr.children[columnIndex]) {
          const cell = childTr.children[columnIndex];
          cell.classList.add('tralit-table-cell-row-hover');
        }
      }
    });
  },
});
